import { render, staticRenderFns } from "./PfReportingFront.vue?vue&type=template&id=8f565b48"
import script from "./PfReportingFront.vue?vue&type=script&lang=js"
export * from "./PfReportingFront.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports